"use client";

import React from "react";
import { ArrowUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const services = [{
    name: "Loft conversion",
    href: "#"
  }, {
    name: "House extension",
    href: "#"
  }, {
    name: "Kitchen installation",
    href: "#"
  }, {
    name: "Full house renovation",
    href: "#"
  }, {
    name: "Property maintenance",
    href: "#"
  }, {
    name: "Bathroom installation",
    href: "#"
  }, {
    name: "Plumbing services",
    href: "#"
  }, {
    name: "Electrical services",
    href: "#"
  }, {
    name: "Commercial renovations",
    href: "#"
  }, {
    name: "Architectural design services",
    href: "#"
  }];
  return <footer data-section-id="21604" id="solidtrust-legacy" className="dark bg-background text-foreground py-20 px-8 border-t border-border/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8">
          <div className="flex flex-col gap-6">
            <Link to="/" className="flex-shrink-0 z-50 relative">
              <img src="https://solidtrustbuilder.com/wp-content/uploads/2026/03/1a092238-d084-427b-879c-6eb67dbd4e34.png" alt="SolidTrust Builders" className="object-contain !h-[100px] !w-[90px]" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-sans uppercase tracking-tight">
              North West London's Premier Builders. Specializing in high-end loft conversions and luxury home extensions.
            </p>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="text-xs font-bold tracking-widest uppercase text-foreground font-sans">
              Expert Services
            </h3>
            <nav className="flex flex-col gap-3">
              {services.map((service, i) => <Link key={i} to={service.href} data-index={i} className="text-sm text-muted-foreground hover:text-foreground transition-colors font-sans">
                  {service.name}
                </Link>)}
            </nav>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="text-xs font-bold tracking-widest uppercase text-foreground font-sans">
              Contact Office
            </h3>
            <nav className="flex flex-col gap-3">
              <span className="text-sm text-muted-foreground font-sans">
                North West London, UK
              </span>
              <Link to="mailto:build@solidtrust.com" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-sans">info@solidtrustbuilders.com</Link>
              <Link to="tel:02080000000" className="text-sm text-muted-foreground hover:text-foreground transition-colors font-sans">+44 7810664982</Link>
              
            </nav>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-muted-foreground font-sans">
          <p className="uppercase tracking-widest text-[10px]">© {new Date().getFullYear()} SolidTrust Builders. Registered in England & Wales.</p>
          <button onClick={scrollToTop} className="group flex items-center gap-2 text-foreground hover:text-muted-foreground transition-colors cursor-pointer" aria-label="Scroll to top">
            <span className="uppercase tracking-widest text-xs font-bold">Back to Top</span>
            <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1" />
          </button>
        </div>
      </div>
    </footer>;
}